import { cn } from '@tsgecart/ui';

export interface AdminSkeletonProps {
  className?: string;
  /** Number of stacked skeleton lines (default 1). */
  lines?: number;
}

/** Respects `prefers-reduced-motion` via the `motion-reduce:animate-none` Tailwind variant -- never a hardcoded animation a user has asked their OS to suppress. */
export function AdminSkeleton({ className, lines = 1 }: AdminSkeletonProps) {
  return (
    <div className="w-full space-y-2" role="presentation" aria-hidden="true">
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          className={cn(
            'motion-reduce:animate-none h-4 animate-pulse rounded-md bg-gray-200',
            className,
          )}
        />
      ))}
    </div>
  );
}
